import './vendor/jquery.yafov';
import './icmib/home/validations';
import {
  buildErrorMessage,
  initUserRegistrationValidation,
  removeErrorMessage,
} from './icmib/validations';

ICMIB.buildErrorMessage = buildErrorMessage;
ICMIB.removeErrorMessage = removeErrorMessage;
ICMIB.validations = { initUserRegistrationValidation };
